import ControlArea from "components/Layout/control-area";
import {useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {getAllDemoStores} from "store/actions";
import Icon from "assets/svgs/employee.svg";
import BootyPagination from "components/shared/pagination";
import {useNavigate, useSearchParams} from "react-router-dom";
import {handleErrMsg} from "helpers/functions";
import {toastErrorMessage} from "helpers/toaster/toastErrorMessage";
import TableControl from "components/shared/table";
import {Dropdown} from "react-bootstrap";
import {getId} from "helpers/functions";
import { deleteDemoStore } from "store/actions";

const DemoStores = () => {
    const {demoStores, loading, error} = useSelector(
        (state) => state.demoStores
    );
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const {formatMessage, locale} = useIntl();
    const [isDispatched, setIsDispatched] = useState(false);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        setIsDispatched(true);
        dispatch(getAllDemoStores(searchParams));
    }, [dispatch, searchParams]);

    // error
    useEffect(() => {
        if (error && isDispatched) {
            toastErrorMessage(formatMessage({id: handleErrMsg(error)}), locale);
        }
    }, [error, formatMessage, locale, isDispatched]);
    const handleEditTheme = (id) => {
        navigate(`/demoStores/${id}`);
    };

    const handleDeleteTheme = (id) => {
        dispatch(deleteDemoStore(id));
    };

    const columns = [
        {
            name: <FormattedMessage id="storeName" />,
            selector: (row) => row?.storeName,
            sortable: true,
        },
        {
            name: <FormattedMessage id="storeEmail" />,
            selector: (row) => row?.storeEmail || row?.email,
            sortable: true,
            style: {direction: "ltr"},
        },
        {
            name: <FormattedMessage id="storeLink" />,
            selector: (row) => <a href={row?.storeLink}>{row?.storeLink}</a>,
            sortable: true,
            style: {direction: "ltr"},
        },

        {
            cell: (row) => (
                <>
                    {
                        <div className="global-dropdown">
                            <Dropdown>
                                <Dropdown.Toggle>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-three-dots-vertical"
                                        viewBox="0 0 16 16">
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                    </svg>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() =>
                                            handleEditTheme(getId(row))
                                        }> 
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            fill="#fff"
                                            className="bi bi-pencil edit"
                                            viewBox="0 0 16 16">
                                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                                        </svg>
                                        <FormattedMessage id={"edit"} />
                                    </Dropdown.Item>

                                    <Dropdown.Item
                                        onClick={() =>
                                            handleDeleteTheme(getId(row))
                                        }>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            fill="#fff"
                                            className="bi bi-trash delete"
                                            viewBox="0 0 16 16">
                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                            />
                                        </svg>
                                        <FormattedMessage id={"delete"} />
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                </>
            ),
            allowOverflow: true,
            button: true,
            width: "56px",
        },
    ];
    return (
        <div className="applications-wrap">
            <ControlArea
                btnTxt={<FormattedMessage id={"addDemoStore"} />}
                cardTxt={<FormattedMessage id={"demoStores"} />}
                icon={Icon}
                url="/demoStores/add"
            />
            <TableControl
                title={"demoStoresTableShowAll"}
                columns={columns}
                data={demoStores}
                loading={loading}
            />
            <BootyPagination metaData={demoStores?.metadata} />
        </div>
    );
};

export default DemoStores;
